import React from 'react'
import brazilWaxingBanner from "./../../../../../Images/Blog/Everything_About_Brazilian_Waxing/Banner Image.png";

const BrazilianWaxingImg = () => {
  return (
    <div className="pediManicureImg">
    <img src={brazilWaxingBanner} alt="brazilWaxingBanner" loading='lazy'/>
    </div>
  )
}

export default BrazilianWaxingImg
